module.exports = __webpack_public_path__ + "img/品牌类别.729bef37.png";